import { createClient } from '@supabase/supabase-js';

// Supabase Cloud Configuration
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || 'https://sergdrdmyoyjftekhyeg.supabase.co';
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InNlcmdkcmRteW95amZ0ZWtoeWVnIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTk4NTE4NTcsImV4cCI6MjA3NTQyNzg1N30.msccJowQYr3fMiJ3pSVdAL7sJVKgglr7du6knXooNbE';

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
  },
  realtime: {
    params: {
      eventsPerSecond: 10,
    },
  },
});

export default supabase;
